import { CheckBoxIcon } from '../../../../assets';

export const PHYSICIAN_ENGAGEMENT_CHANNELS = [
    'All',
    'E-mail',
    'Programmatic',
    'Direct Mail',
    'EHR',
    'Mobile',
    'Peer to Peer',
    'Point of Care'
];

export const BAR_CHART_LEGENDS = [
    { label: 'E-mail', icon: <CheckBoxIcon fill="#FD853A"/> },
    { label: 'Programmatic', icon: <CheckBoxIcon fill="#7A5AF8" /> },
    { label: 'Direct mail', icon: <CheckBoxIcon fill="#12B76A"/> },
    { label: 'EHR', icon: <CheckBoxIcon fill="#2E90FA"/> },
    { label: 'Mobile', icon: <CheckBoxIcon fill="#6172F3"/> },
    { label: 'Peer To Peer', icon: <CheckBoxIcon fill="#F63D68"/> },
    { label: 'Point of Care', icon: <CheckBoxIcon fill="#EE46BC"/> }
];

export const PHYSICIAN_ENGAGEMENT_SEGEMENT_CHART_OPTIONS = {
    colors: [
        '#F3DBF1',
        '#E9BEE3',
        '#DB97D2',
        '#C76EBA',
        '#AD509E',
        '#8C3F7D',
        '#733567',
        '#733567'
    ],
    lang: { noData: 'No data to display' },
    noData: {
        style: {
            fontWeight: 'bold',
            fontSize: '15px',
            color: '#303030'
        }
    },
    chart: {
        type: 'pie',
        backgroundColor: null,
        plotBackgroundColor: null,
        plotBorderWidth: 0,
        plotShadow: false
    },
    title: { text: null },
    subtitle: { text: null },
    exporting: { enabled: false },
    credits: { enabled: false },
    tooltip: {
        useHTML: true,
        backgroundColor: '#000',
        style: {
            color: '#fff',
            fontSize: '10px'
        },
        formatter: function () {
            return `<b>${this.key}</b>: ${this.y}% <br>`;
        }
    },
    legend: {
        useHTML: true,
        layout: 'vertical',
        verticalAlign: 'bottom',
        itemStyle: {
            color: '#667085',
            fontWeight: 400,
            fontSize: '12px'
        },
        labelFormatter() {
            return `${this.options.name} ${this.options.y + '%'}`;
            return `<span>${
                this.options.name
            }</span> <span class="donut-chart-legend-value">${
                this.options.y + '%'
            }</span>`;
            // return `<div class="flex-row justify-space-between">
            //             <div class="donut-chart-legend-segment">${this.options.name}</div>
            //             <div class="donut-chart-legend-value">${this.options.y + '%'} </div>
            //         </div>`
        }
    },
    plotOptions: {
        pie: {
            shadow: false,
            borderWidth: 0,
            allowPointSelect: false,
            size: '100%',
            dataLabels: { enabled: false }
        }
    },
    series: [
        {
            name: 'Physician Engagement Segments',
            data: [
                {
                    name: 'Segment A',
                    y: 19.77
                },
                {
                    name: 'Segment B',
                    y: 27
                },
                {
                    name: 'Segment C',
                    y: 7.98
                },
                {
                    name: 'Segment D',
                    y: 12.17
                },
                {
                    name: 'Segment E',
                    y: 3.8
                },
                {
                    name: 'Infectious Disease Specialist',
                    y: 4.94
                },
                {
                    name: 'Primary HIV HCP',
                    y: 17.11
                },
                {
                    name: 'Not Available',
                    y: 5.32
                }
            ],
            size: '100%',
            innerSize: '50%',
            showInLegend: true,
            borderRadius: 0
        }
    ]
};

export const PHYSICIAN_ENGAGEMENT_AFFILIATION_TYPE_CHART_OPTIONS = {
    colors: [
        '#F3DBF1',
        '#E9BEE3',
        '#DB97D2',
        '#C76EBA',
        '#AD509E',
        '#8C3F7D',
        '#733567'
    ],
    lang: { noData: 'No data to display' },
    noData: {
        style: {
            fontWeight: 'bold',
            fontSize: '15px',
            color: '#303030'
        }
    },
    chart: {
        type: 'pie',
        backgroundColor: null,
        plotBackgroundColor: null,
        plotBorderWidth: 0,
        plotShadow: false
    },
    title: { text: null },
    subtitle: { text: null },
    exporting: { enabled: false },
    credits: { enabled: false },
    tooltip: {
        useHTML: true,
        backgroundColor: '#000',
        style: {
            color: '#fff',
            fontSize: '10px'
        },
        formatter: function () {
            return `<b>${this.key}</b>: ${this.y}% <br>`;
        }
    },
    legend: {
        useHTML: true,
        layout: 'vertical',
        verticalAlign: 'bottom',
        itemStyle: {
            color: '#667085',
            fontWeight: 400,
            fontSize: '12px'
        },
        labelFormatter() {
            return `${this.options.name} ${this.options.y + '%'}`;
        }
    },
    plotOptions: {
        pie: {
            shadow: false,
            borderWidth: 0,
            allowPointSelect: false,
            size: '100%',
            dataLabels: { enabled: false }
        }
    },
    series: [
        {
            name: 'Physician Engagement Affiliation Type',
            data: [
                {
                    name: 'Institution',
                    y: 42.5
                },
                {
                    name: 'Community',
                    y: 33.2
                },
                {
                    name: 'Academic',
                    y: 18.6
                },
                {
                    name: 'Unavailable',
                    y: 5.7
                }
            ],
            size: '100%',
            innerSize: '50%',
            showInLegend: true,
            borderRadius: 0
        }
    ]
};

export const CHART_OPTIONS = {
    chart: {
        stacked: true,
        toolbar: { show: false }
    },
    noData: {
        text: 'No data to display',
        align: 'center',
        verticalAlign: 'middle',
        offsetX: 0,
        offsetY: 0,
        style: {
            color: '#000000',
            fontSize: '14px'
        }
    },
    legend: {
        show: true,
        position: 'top',
        horizontalAlign: 'center',
        markers: {
            shape: 'circle',
            radius: 6
        }
    },
    xaxis: {
        title: {
            text: 'Channels',
            style: {
                color: '#667085',
                fontSize: '12px',
                fontFamily: 'Inter',
                fontWeight: 500,
                cssClass: 'apexcharts-xaxis-title'
            }
        },
        crosshairs: { show: false }
    },
    yaxis: {
        title: {
            text: 'Total Physicians',
            style: {
                color: '#667085',
                fontSize: '12px',
                fontFamily: 'Inter',
                fontWeight: 500,
                cssClass: 'apexcharts-yaxis-title'
            }
        },
        min: 0,
        max: 10,
        tickAmount: 5
    },
    tooltip: {
        enabled: true,
        custom: function ({
            series, seriesIndex, dataPointIndex, w 
        }) {
            const value = series[seriesIndex][dataPointIndex];
            const label = w.globals.labels[dataPointIndex];
            const data = w.globals.initialSeries[seriesIndex].data[dataPointIndex];
            const { colors } = w.globals;
            const serieLabels = w.globals.seriesNames;
            let serieItems = '';
            
            const serieTitle= '<div class="apexcharts-tooltip-title">'+label+'</div>';
            
            series.forEach((array, index) => {
                const serieValue = array[dataPointIndex];
                const serieLabel = serieLabels[index];
                const serieColor = colors[index];
      
                if (serieValue && serieValue !== 0) {
                    serieItems +=
                    '<div class="apexcharts-tooltip-series-group apexcharts-active" style="order:'+index+';display:flex;">'+
                        '<span class="apexcharts-tooltip-marker" style="background-color: '+serieColor+';"></span>'+
                        '<div class="apexcharts-tooltip-text">'+ 
                            '<div class="apexcharts-tooltip-y-group">' +
                                '<span class="apexcharts-tooltip-text-y-label">' + serieLabel +':</span>'+
                                '<span class="apexcharts-tooltip-text-y-value">'+serieValue+'</span>'+
                            '</div>'+
                        '</div>'+
                    '</div>';
                }
              
            });
           
            return serieTitle + serieItems;
        }
    },
    plotOptions: {
        bar: {
            columnWidth: 50,
            borderRadius: 2,
            dataLabels: { position: 'top' }
        }
        
    },
    stroke: {
        show: true,
        width: 2,
        colors: ['transparent']
    },
    dataLabels: {
        enabled: true,
        textAnchor: 'middle',
        style: {
            colors: ['#FFFFFF'],
            fontSize: '12px',
            fontWeight: '500'                    
        },
        formatter: function (val, opt) {
            const formattedVal = val.toString();
            return formattedVal;
        }
    }

};


export const CHART_SERIES = [
    {
        name: 'Physicians Engagement Channel',
        data: [
            {
                x: 'E-mail', y: 245, fillColor: '#FD853A' 
            },
            {
                x: 'Programmatic', y: 423, fillColor: '#7A5AF8' 
            },
            {
                x: 'Direct mail', y: 266, fillColor: '#12B76A' 
            },
            {
                x: 'EHR', y: 371, fillColor: '#2E90FA' 
            },
            {
                x: 'Mobile', y: 251, fillColor: '#6172F3' 
            },
            {
                x: 'Peer To Peer', y: 270, fillColor: '#F63D68' 
            },
            {
                x: 'Point of Care', y: 328, fillColor: '#EE46BC' 
            }
        ]
    }
];

export const NPI_ENGAGEMENT_SEGEMENT_CHART_OPTIONS = {
    colors: [
        '#F3DBF1',
        '#E9BEE3',
        '#DB97D2',
        '#C76EBA',
        '#AD509E',
        '#8C3F7D',
        '#733567',
        '#733567'
    ],
    lang: { noData: 'No data to display' },
    noData: {
        style: {
            fontWeight: 'bold',
            fontSize: '15px',
            color: '#303030'
        }
    },
    chart: {
        type: 'pie',
        backgroundColor: null,
        plotBackgroundColor: null,
        plotBorderWidth: 0,
        plotShadow: false
    },
    title: { text: null },
    subtitle: { text: null },
    exporting: { enabled: false },
    credits: { enabled: false },
    tooltip: {
        useHTML: true,
        backgroundColor: '#000',
        style: {
            color: '#fff',
            fontSize: '10px'
        },
        formatter: function () {
            return `<b>${this.key}</b>: ${this.y} <br>`;
        }
    },
    legend: {
        useHTML: true,
        layout: 'vertical',
        verticalAlign: 'bottom',
        itemStyle: {
            color: '#667085',
            fontWeight: 400,
            fontSize: '12px'
        },
        labelFormatter() {
            return `${this.options.name} ${this.options.y}`;
            return `<span>${
                this.options.name
            }</span> <span class="donut-chart-legend-value">${
                this.options.y
            }</span>`;
            // return `<div class="flex-row justify-space-between">
            //             <div class="donut-chart-legend-segment">${this.options.name}</div>
            //             <div class="donut-chart-legend-value">${this.options.y + '%'} </div>
            //         </div>`
        }
    },
    plotOptions: {
        pie: {
            shadow: false,
            borderWidth: 0,
            allowPointSelect: false,
            size: '100%',
            dataLabels: { enabled: false }
        }
    },
    series: [
        {
            name: 'Physician Engagement Segments',
            data: [
                {
                    name: 'Segment A',
                    y: 19.77
                },
                {
                    name: 'Segment B',
                    y: 27
                },
                {
                    name: 'Segment C',
                    y: 7.98
                },
                {
                    name: 'Segment D',
                    y: 12.17
                },
                {
                    name: 'Segment E',
                    y: 3.8
                },
                {
                    name: 'Infectious Disease Specialist',
                    y: 4.94
                },
                {
                    name: 'Primary HIV HCP',
                    y: 17.11
                },
                {
                    name: 'Not Available',
                    y: 5.32
                }
            ],
            size: '100%',
            innerSize: '50%',
            showInLegend: true,
            borderRadius: 0
        }
    ]
};
